var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x96\xB4\xEB\x93\x9C\xEB\xAF\xBC_01\xEA\xB8\xB0\xEB\xB3\xB8\xEC\xA0\x95\xEB\xB3\xB4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1237,
    transform: "translate(-1716 -712)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: -67,
    y: -8,
    width: 120,
    height: 32,
    rx: 8,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00A876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4",
    d: "M11.7175 6.12132L7.12132 10.7175L5 8.59619",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0adfe03e14d9e04b640577c89a3bf3b2.svg";
export { ForwardRef as ReactComponent };